const applyFilters = async (
  listOfTags,
  listOfUsers,
  groupedFlagsByText,
  isMine
) => {
  let tagsToFilter = [];
  let usersToFilter = [];
  let filtered = false;
  let filteredObject = {};
  let objectToFilter = {};

  localStorage.setItem('listOfTags', JSON.stringify(listOfTags));
  localStorage.setItem('listOfUsers', JSON.stringify(listOfUsers));
  if (listOfUsers?.length > 0) {
    if (isMine) {
      Object.entries(groupedFlagsByText).forEach(([key, flags]) => {
        const filteredFlags = flags.filter(
          (flag) =>
            flag.isMine ||
            flag.autoType === 2 ||
            (listOfUsers.includes(flag.userId) && flag.isShared)
        );
        if (filteredFlags.length > 0) {
          objectToFilter[key] = filteredFlags;
          filteredFlags[0].userId > 0
            ? usersToFilter.push(filteredFlags[0].userId)
            : null;
        }
      }),
        (filteredObject = objectToFilter);
    } else {
      Object.entries(groupedFlagsByText).forEach(([key, flags]) => {
        const filteredFlags = flags.filter(
          (flag) => listOfUsers.includes(flag.userId) && flag.isShared
        );
        if (filteredFlags.length > 0) {
          objectToFilter[key] = filteredFlags;
          usersToFilter.push(filteredFlags.map((item) => item.userId));
        }
      }),
        (filteredObject = objectToFilter);
    }
  }

  let tagList = listOfTags;
  let unTaggedObject = [];
  let flashObject = [];

  if (listOfTags?.length > 0) {
    listOfTags[0] === 'all' && listOfTags.length > 1
      ? ((tagList = tagList.filter((tag) => tag !== 'all')), (filtered = true))
      : (filtered = false);
    if (listOfTags.includes('Untagged')) {
      Object.keys(filteredObject)?.length > 0
        ? (unTaggedObject = filterData(filteredObject, 'flashflag'))
        : (unTaggedObject = filterData(groupedFlagsByText, 'flashflag'));
      tagList = tagList.filter((tag) => tag !== 'Untagged');
    }
    if (listOfTags.includes('FLASH')) {
      Object.keys(filteredObject)?.length > 0
        ? (Object.entries(filteredObject).forEach(([key, flags]) => {
            const filteredFlags = flags.filter(
              (flag) => !flag.flashflag && flag.tag === 'FLASH'
            );
            if (filteredFlags.length > 0) {
              objectToFilter[key] = filteredFlags;
            }
          }),
          (flashObject = objectToFilter))
        : (Object.entries(groupedFlagsByText).forEach(([key, flags]) => {
            const filteredFlags = flags.filter(
              (flag) => !flag.flashflag && flag.tag === 'FLASH'
            );
            if (filteredFlags.length > 0) {
              objectToFilter[key] = filteredFlags;
            }
          }),
          (flashObject = objectToFilter));
      tagList = tagList.filter((tag) => tag !== 'FLASH');
    }

    tagList.length > 0
      ? filtered
        ? Object.keys(filteredObject)?.length > 0
          ? (Object.entries(filteredObject).forEach(([key, flags]) => {
              const filteredFlags = flags.filter((flag) =>
                tagList.includes(flag.tag)
              );
              if (filteredFlags.length > 0) {
                objectToFilter[key] = filteredFlags;
              }
            }),
            (filteredObject = objectToFilter))
          : (Object.entries(groupedFlagsByText).forEach(([key, flags]) => {
              const filteredFlags = flags.filter((flag) =>
                tagList.includes(flag.tag)
              );
              if (filteredFlags.length > 0) {
                objectToFilter[key] = filteredFlags;
              }
            }),
            (filteredObject = objectToFilter))
        : Object.keys(filteredObject)?.length > 0
        ? null
        : (filteredObject = groupedFlagsByText)
      : null;
  }

  if (tagList?.length > 0) {
    filteredObject = unifyObjects(filteredObject, unTaggedObject, flashObject);
  } else {
    filteredObject = unifyObjects(unTaggedObject, flashObject);
  }

  let array = [];

  if (listOfTags?.includes('all') && listOfTags?.length > 1) {
    tagsToFilter = listOfTags.filter((tag) => tag !== 'all');
  } else if (listOfTags?.length > 1) {
    tagsToFilter = listOfTags;
  }

  array.push(filteredObject);
  array.push(tagsToFilter);
  array.push(removeDuplicates(usersToFilter));

  return array;
};

function removeDuplicates(arr) {
  return arr?.filter((item, index) => arr.indexOf(item) === index);
}

const filterData = (object, filterBy) => {
  let filteredObject = {};
  Object.entries(object).forEach(([key, flags]) => {
    const filteredFlags = flags.filter((flag) =>
      filterBy === 'isShared'
        ? flag.isShared
        : filterBy === 'isMine'
        ? flag.isMine
        : flag.flashflag
    );

    if (filteredFlags.length > 0) {
      filteredObject[key] = filteredFlags;
    }
  });
  return filteredObject;
};

const unifyObjects = (...objects) => {
  const result = {};

  objects.forEach((obj) => {
    Object.keys(obj).forEach((key) => {
      if (result[key]) {
        result[key] = [...result[key], ...obj[key]];
      } else {
        result[key] = [...obj[key]];
      }
    });
  });

  return result;
};

const groupedByText = (list, unmatchedNotes = []) => {
  let array = [];

  if (list?.length > 0) {
    list?.map(
      (item) =>
        (array = [
          ...array,
          ...item.notesInfos.map((note) => ({
            ...note,
            pageStart: item.pageStart,
            pageEnd: item.pageEnd
          }))
        ])
    );
  }

  if (unmatchedNotes?.length > 0) {
    array = [...array, ...unmatchedNotes];
  }

  let arrayOfIds = [];
  const groupedNotes = array.reduce((acc, note) => {
    const key = note.text?.replace(/\r?\n|\r/g, '');
    if (!acc[key]) {
      acc[key] = [];
    }
    if (!arrayOfIds.includes(note.noteId)) {
      acc[key].push(note);
      arrayOfIds.push(note.noteId);
    }
    return acc;
  }, {});

  return groupedNotes;
};


/**
 * Add trackPosition -1 to an unmatched flag
 *
 * @param {unknown} unmatchedFlag - Unmatched Flag
 * @returns {unknown} Unmatched Flag with trackPosition -1
 */
function addTrackPositionToUnmatchedFlag(unmatchedFlag) {
  return {
    ...unmatchedFlag,
    trackPosition: -1
  };
}

/**
 *
 * @param {unkown[]} array1 - Array 1
 * @param {unkown[]} array2 - Array 2
 * @returns {boolean} - True if arrays are equal, false otherwise
 */
function arraysAreEqual(array1, array2) {
  if (array1.length !== array2.length) return false;
  for (let i = 0; i < array1.length; i++) {
    if (array1[i] !== array2[i]) return false;
  }
  return true;
}

export {
  applyFilters,
  groupedByText,
  addTrackPositionToUnmatchedFlag,
  arraysAreEqual
};
